import {Competitor} from 'packages/common-types/schema-types';
import {StandingPlayer} from 'packages/common-types/base-types';

export const TABLE_HEADERS = [
  'Pos',
  'Grupo',
  'Atleta/Miembro',
  'PJ',
  'PG',
  'PP',
  'DIF.PART',
  'PTOS FAVOR',
  'PTS CONTRA',
  'EFECTIVIDAD',
  'DIFF EFFECT',
];

export const calculateDiffEffectiveness = (competitors: Competitor[]) => {
  const sortedByPosition = competitors
    .map((competitor) => competitor)
    .sort((a, b) => a.place - b.place);

  return sortedByPosition?.map((competitor, index) => {
    if (index === 0) {
      return {
        ...competitor,
        diffEffect: 0,
      };
    }
    // Calculate the difference between the current and previous position.
    return {
      ...competitor,
      diffEffect: Math.abs(
        competitor.pointDifference - sortedByPosition[index - 1].pointDifference
      ),
    };
  }) as StandingPlayer[];
};
